// extracted by mini-css-extract-plugin
export var animationContainer = "_es-0";
export var asteriskIcon = "_es-8";
export var conversationLeftSection = "_es-4";
export var conversationListItem = "_es-3";
export var conversationMiddleSection = "_es-5";
export var conversationRightSection = "_es-6";
export var detailsContent = "_es-1";
export var listContainer = "_es-7";
export var modalContent = "_es-2";